import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 50px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const TriggerHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 50px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const TypographyContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const HeaderLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  
  & > span:last-child{
    text-transform: capitalize;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const ProgressModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  text-align: center;
`;

export const Spinner = styled.div`
  border: 3px solid ${(props) => props.theme.colors.aquaHaze};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;

  &.creating-trigger {
    border-top: 3px solid ${(props) => props.theme.colors.curiousBlue};
  }

  &.creating-flow {
    border-top: 3px solid ${(props )=> props.theme.colors.darkOrange};
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const SuccessIcon = styled.div`
  color: ${(props) => props.theme.colors.mediumGreen};
  font-size: 30px;
  margin: 0 auto 10px;
`;

export const SubText = styled.div`
  color: #${(props) => props.theme.colors.grey};
  margin-top: 5px;
`;

export const SuccessText = styled.div`
  color: ${(props) => props.theme.colors.mediumGreen};
`;
